export const ordinalColors = {
    1: { primary: '#A62D20', secondary: '#762219', text: 'white' },
    2: { primary: '#0089CF', secondary: '#0076B2', text: 'white' },
    3: { primary: '#82C341', secondary: '#79B63D', text: 'white' },
    4: { primary: '#FFD400', secondary: '#FFC900', text: 'black' },
};



// WEBPACK FOOTER //
// ./src/constants/CouncilOrdinals.ts